module.exports = __webpack_public_path__ + "img/objective-3@2x.63d416f3.jpg";